import { IfWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('If')
export class IfConnectorProvider extends ConnectorProvider<IfWorkflowNode> {}
